import type { SiteConfig } from './types'
import jsonConfig from '@data/examples/site-config.json'

export const baseConfig: Partial<SiteConfig> = {
  contact: {
    companyName: '安徽中标环境科技有限公司',
    establishedDate: '2018-12-28',
    phone: '0551-65589899',
    email: 'contact@zbhj-tech.com',
    address: '安徽省合肥市高新区长宁社区服务中心创新大道2800号创新产业园二期F5幢',
    website: 'https://zbhj-tech.com/'
  },
  seo: {
    title: '安徽中标环境科技有限公司 · zbhj-tech.com',
    canonical: 'https://zbhj-tech.com/'
  },
  tiandituKey: 'cbcd616f2034a1d44aef33dbb95e5bc3'
}

const sanitize = <T extends object>(value?: T | null) => {
  if (!value) return {}
  return Object.fromEntries(
    Object.entries(value).filter(([, v]) => v !== undefined && v !== null)
  ) as Partial<T>
}

export function mergeSiteConfig(
  base: Partial<SiteConfig>,
  overrides?: Partial<SiteConfig>
): SiteConfig {
  const safeBase = sanitize(base) as Partial<SiteConfig>
  const incoming = sanitize(overrides) as Partial<SiteConfig>

  return {
    ...safeBase,
    ...incoming,
    contact: {
      ...sanitize(safeBase.contact),
      ...sanitize(incoming.contact)
    } as SiteConfig['contact'],
    seo: {
      ...sanitize(safeBase.seo),
      ...sanitize(incoming.seo)
    } as SiteConfig['seo']
  } as SiteConfig
}

export const siteConfig: SiteConfig = mergeSiteConfig(baseConfig, jsonConfig)
